// NotificationProvider.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { getUnreadNotificationCount } from "../../Services/apiService";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifiCount, setNotifiCount] = useState();
  const sessionId = localStorage.getItem("sessionId");
   const language = localStorage.getItem("Lang");

  const fetchNotificationCount = async () => {
    try {
      const count = await getUnreadNotificationCount();
      console.log("Notification count data:", count);

      setNotifiCount(count || 0);
    } catch (error) {
      console.error("Count API error:", error);
    }
  };

  useEffect(() => {
    if (sessionId) {
      fetchNotificationCount();
      // Optional: refresh count every 30s
      const interval = setInterval(fetchNotificationCount, 30000);
      return () => clearInterval(interval);
    }
  }, [sessionId]);

  return (
    <NotificationContext.Provider value={{ notifiCount, setNotifiCount, fetchNotificationCount }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
